// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import React from "react";

export const getCartLineErrorMessages = (cartLines: CartLineModel[], currentCartLine: CartLineModel) => {
    const errorMessages: React.ReactNode[] = [];
    // IF cartline isRestricted or is not Active that means it's not purchasable
    if (currentCartLine.isRestricted) {
        errorMessages.push(translate("Restricted product"));
    }

    if (!currentCartLine.isActive) {
        errorMessages.push(translate("Inactive Product"));
    }

    return errorMessages.length > 0 ? errorMessages : undefined;
};
